export const TREE_EXPAND = 'tree-expand';
export const LIST_FILTER = 'filter';
export const FILTER_NS = 'app.filters';